/* ==========================================================================
   global.js — Réglages GLOBAUX (For.me)
   --------------------------------------------------------------------------
   À CHARGER dans theme.liquid (sur toutes les pages), comme les autres :
     <script src="{{ 'global.js' | asset_url }}" defer></script>

   RÔLE : sur TOUT le site, toute graisse de police 600 -> 500.
   (Le CSS ne peut pas cibler par graisse calculée : impossible de faire
    « tous les éléments en 600 » en pur CSS -> on le fait en JS.)
   Les autres graisses (400, 700…) ne sont PAS touchées.
   ========================================================================== */
(function () {
  'use strict';

  var FROM = '600';   // graisse à remplacer
  var TO   = '500';   // graisse cible

  /* ÉCHAPPATOIRE : data-fm-graisse
     -------------------------------------------------------------------------
     Un élément portant `data-fm-graisse` (ou placé dans un tel élément) garde
     la graisse qu'on lui a donnée. Sans ça, un réglage de graisse dans
     l'éditeur de thème est un leurre : l'auteur choisit 600, ce script le
     repasse en 500 !important, et le réglage n'a aucun effet visible.
     Posé aujourd'hui sur les titres et descriptions des cartes de couverture
     (bloc fm-cover-card et slide de couverture de custom-variant-list). */
  function exempte(el) {
    return !!(el.closest && el.closest('[data-fm-graisse]'));
  }

  // Repasse un élément de FROM -> TO (seulement s'il est réellement en FROM).
  function check(el) {
    if (!el || el.nodeType !== 1) return;
    if (exempte(el)) return;
    // getComputedStyle renvoie la valeur numérique effective ("600", "500"...)
    if (getComputedStyle(el).fontWeight === FROM) {
      el.style.setProperty('font-weight', TO, 'important');
    }
  }

  // Balaie un élément + tous ses descendants.
  function scan(root) {
    if (!root || root.nodeType !== 1) return;
    check(root);
    var els = root.querySelectorAll('*');
    for (var i = 0; i < els.length; i++) check(els[i]);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    scan(document.body);

    // Rattrape tout contenu ajouté après coup (changement de variante, panier
    // qui s'ouvre, recommandations chargées en AJAX, pop-ups…). On ne balaie
    // que les nouveaux sous-arbres -> léger.
    new MutationObserver(function (muts) {
      for (var m = 0; m < muts.length; m++) {
        var added = muts[m].addedNodes;
        for (var n = 0; n < added.length; n++) scan(added[n]);
      }
    }).observe(document.body, { childList: true, subtree: true });
  });
})();

/* Active viewport-fit=cover (pour le rendu sous l'encoche iOS) */
(function () {
  var vp = document.querySelector('meta[name="viewport"]');
  if (vp && !/viewport-fit/.test(vp.getAttribute('content') || '')) {
    vp.setAttribute('content', vp.getAttribute('content') + ', viewport-fit=cover');
  }
})();

/* Fond flouté derrière l'encoche iPhone (Safari 26) */
(function () {
  if (document.getElementById('fm-notch-fill')) return;
  var el = document.createElement('div');
  el.id = 'fm-notch-fill';
  document.body.appendChild(el);
})();

/* ===== Lueur de la photo produit sur le bloc d'infos ===== */
(function () {
  function initGlow() {
    if (!document.querySelector('#MainContent[data-template^="product"]')) return;
    var details = document.querySelector('.product-details') || document.querySelector('.product-information__aside');
    var media = document.querySelector('.product-information__media');
    if (!details || !media) return;

    function currentSrc() {
      var img =
        media.querySelector('.fm-active .product-media__image') ||
        media.querySelector('slideshow-slide[aria-hidden="false"] .product-media__image') ||
        media.querySelector('.product-media__image');
      return img ? (img.currentSrc || img.src || '') : '';
    }

    var last = '';
    function update() {
      var src = currentSrc();
      if (src && src !== last) {
        last = src;
        details.style.setProperty('--fm-glow-img', 'url("' + src + '")');
      }
    }

    update();
    new MutationObserver(update).observe(media, {
      attributes: true,
      attributeFilter: ['class', 'src', 'aria-hidden'],
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGlow);
  } else {
    initGlow();
  }
})();


/* ============================================================
   BADGE « NEW » sur les swatchs (nuancier + variant picker)
   ------------------------------------------------------------
   À COLLER à la fin de  assets/global.js
   (aucun fichier natif du thème n'est modifié).

   Le badge est posé DANS le <label> du swatch -> il défile et suit
   l'animation de survol nativement (aucun recalage JS au scroll).
   Il découpe le swatch (couleur + barre "épuisé" + anneau actif).

   👉 Renseigne tes teintes dans NEW_VARIANTS ci-dessous.
      Casse et espaces ignorés (Candy = candy). Accents = exacts.
   ============================================================ */
(function () {
  // ===== CONFIG : noms des variantes qui reçoivent le badge NEW =====
  var NEW_VARIANTS = [
    'Candy',
    'Honey Hour',
    'Caramel',
    'Cinnamon',
    'Sunkissed',
    'Chestnut',
    'Mocha',
  ];
  // =================================================================

  var norm = function (s) { return (s || '').trim().toLowerCase(); };
  var newSet = NEW_VARIANTS.map(norm).filter(Boolean);

  function injectCSS() {
    if (document.getElementById('fm-new-badge-css')) return;
    var st = document.createElement('style');
    st.id = 'fm-new-badge-css';
    st.textContent =
      '.fm-new-badge{position:absolute;transform:translate(-50%,-50%);pointer-events:none;' +
      'background:#000;color:#fff;font-size:6.5px;font-weight:500;letter-spacing:.02em;line-height:1;' +
      'text-transform:uppercase;padding:2px 5px;border-radius:999px;white-space:nowrap;z-index:5;' +
      'display:flex;align-items:center;justify-content:center;box-sizing:border-box;}' +
      /* page produit (variant picker) : police un peu plus grande */
      '.fm-new-badge--big{font-size:7.5px;padding:2.5px 6px;}' +
      /* carte au repos : badge NOIR, texte BLANC */
      '.product-card .fm-new-badge{background:#000 !important;color:#fff !important;-webkit-text-fill-color:#fff !important;}' +
      /* carte au survol : badge BLANC, texte #212121 (inversion) — DESKTOP only
         (sur mobile pas de survol -> le badge reste noir) */
      '@media (min-width:750px){' +
      '.product-card:hover .fm-new-badge,.product-card:hover product-swatches .fm-new-badge{' +
      'background:#ffffff !important;color:#212121 !important;-webkit-text-fill-color:#212121 !important;}' +
      '}' +
      /* laisser le badge dépasser sous la pastille (page produit) */
      '.variant-picker .variant-option__button-label,' +
      '.variant-picker .variant-option,' +
      '.variant-picker .variant-option__swatch,' +
      '.variant-picker fieldset{overflow:visible !important;}' +
      /* SURVOL (cartes) : on agrandit le LABEL (pastille + découpe + badge
         grandissent ensemble) au lieu du swatch seul */
      '@media (min-width:750px){' +
        '.product-card .variant-option__button-label:hover .swatch,' +
        '.product-card .swatch:hover{transform:none !important;}' +
        '.product-card .variant-option__button-label{transition:transform .2s ease;}' +
        '.product-card .variant-option__button-label:hover{transform:scale(1.17);transform-origin:center center;z-index:2;}' +
      '}' +
      /* MODE MOBILE (fm-has-cut) : on NE masque PAS le swatch (sinon iOS coupe
         l'anneau de sélection) -> on découpe seulement la couleur (::before) et
         la barre "épuisé" (::after). L'anneau reste donc intact. */
      '.swatch.fm-has-cut{background-color:transparent !important;background-image:none !important;position:relative;}' +
      '.swatch.fm-has-cut::before{content:"";position:absolute;inset:0;border-radius:inherit;' +
      'background:var(--swatch-background) center/cover no-repeat;' +
      '-webkit-mask-image:var(--fm-cut);mask-image:var(--fm-cut);' +
      '-webkit-mask-size:100% 100%;mask-size:100% 100%;' +
      '-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;z-index:0;}' +
      '.swatch.fm-has-cut::after{-webkit-mask-image:var(--fm-cut);mask-image:var(--fm-cut);' +
      '-webkit-mask-size:100% 100%;mask-size:100% 100%;' +
      '-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;}';
    document.head.appendChild(st);
  }

  // Nom de la teinte : dans Horizon il est sur l'<input> du <label> (value = nom propre)
  function labelFor(swatch) {
    var label = swatch.closest('label');
    if (label) {
      var input = label.querySelector('input');
      if (input) {
        var v = input.value || input.getAttribute('value') || input.getAttribute('aria-label');
        if (v) return v;
      }
      if (label.getAttribute('aria-label')) return label.getAttribute('aria-label');
      var t = (label.textContent || '').trim();
      if (t) return t;
    }
    var sib = swatch.nextElementSibling;
    if (sib && sib.classList && sib.classList.contains('visually-hidden')) return sib.textContent;
    var host = swatch.closest('[aria-label]');
    if (host) return host.getAttribute('aria-label');
    return '';
  }

  // Construit l'URL d'un masque SVG (rectangle plein SW×SH percé d'un trou
  // pilule = badge + 1.5px, centré en cx,cy).
  /* Largeur du vide transparent entre le badge « NEW » et la pastille, en px
     de chaque cote. C'est LA molette de ce reglage :
       1.5 = filet a peine visible (ancienne valeur)
       2   = separation nette (valeur actuelle)
       3.5 = large, la pastille commence a etre entamee
     Au-dela de 4 sur une pastille de 13px de haut, il ne reste plus grand
     chose de la couleur sous le badge. */
  var TROU_MARGE = 2;

  function holeUrl(SW, SH, cx, cy, bw, bh) {
    var hw = bw + 2 * TROU_MARGE, hh = bh + 2 * TROU_MARGE, r = hh / 2;
    if (r > hw / 2) r = hw / 2;
    var hx = cx - hw / 2, hy = cy - hh / 2;
    var d = 'M0 0H' + SW + 'V' + SH + 'H0Z' +
      'M' + (hx + r) + ' ' + hy +
      'H' + (hx + hw - r) +
      'A' + r + ' ' + r + ' 0 0 1 ' + (hx + hw) + ' ' + (hy + r) +
      'V' + (hy + hh - r) +
      'A' + r + ' ' + r + ' 0 0 1 ' + (hx + hw - r) + ' ' + (hy + hh) +
      'H' + (hx + r) +
      'A' + r + ' ' + r + ' 0 0 1 ' + hx + ' ' + (hy + hh - r) +
      'V' + (hy + r) +
      'A' + r + ' ' + r + ' 0 0 1 ' + (hx + r) + ' ' + hy + 'Z';
    var svg = "<svg xmlns='http://www.w3.org/2000/svg' width='" + SW + "' height='" + SH +
      "'><path fill='#fff' fill-rule='evenodd' d='" + d + "'/></svg>";
    return 'url("data:image/svg+xml,' + encodeURIComponent(svg) + '")';
  }

  // Découpe le swatch. DESKTOP : masque agrandi + no-clip (traverse couleur,
  // barre "épuisé" ET anneau de sélection). MOBILE : on ne masque pas le swatch
  // (iOS couperait l'anneau) -> découpe couleur (::before) + barre (::after).
  function applyCut(sw, W, H, bw, bh, cyRel) {
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    var key = W + '|' + H + '|' + bw + '|' + bh + '|' + Math.round(cyRel) + '|' + (mobile ? 'm' : 'd');
    if (sw._fmCutKey === key) return;
    sw._fmCutKey = key;

    // reset des deux modes
    sw.style.webkitMaskImage = ''; sw.style.maskImage = '';
    sw.style.webkitMaskRepeat = ''; sw.style.maskRepeat = '';
    sw.style.webkitMaskSize = ''; sw.style.maskSize = '';
    sw.style.webkitMaskPosition = ''; sw.style.maskPosition = '';
    sw.style.webkitMaskClip = ''; sw.style.maskClip = '';
    sw.classList.remove('fm-has-cut');
    sw.style.removeProperty('--fm-cut');

    if (mobile) {
      // découpe portée par ::before (couleur) et ::after (barre) — swatch intact
      sw.style.setProperty('--fm-cut', holeUrl(W, H, W / 2, cyRel, bw, bh));
      sw.classList.add('fm-has-cut');
    } else {
      var M = 6, SW = W + 2 * M, SH = H + 2 * M;
      var url = holeUrl(SW, SH, M + W / 2, M + cyRel, bw, bh);
      sw.style.webkitMaskImage = url; sw.style.maskImage = url;
      sw.style.webkitMaskRepeat = 'no-repeat'; sw.style.maskRepeat = 'no-repeat';
      sw.style.webkitMaskSize = SW + 'px ' + SH + 'px'; sw.style.maskSize = SW + 'px ' + SH + 'px';
      sw.style.webkitMaskPosition = (-M) + 'px ' + (-M) + 'px'; sw.style.maskPosition = (-M) + 'px ' + (-M) + 'px';
      sw.style.webkitMaskClip = 'no-clip'; sw.style.maskClip = 'no-clip';
    }
  }

  /* Position de la pastille DANS le label, en coordonnees de mise en page.
     On remonte la chaine des offsetParent au lieu d'utiliser
     getBoundingClientRect(), et c'est tout l'interet : offsetLeft/offsetTop
     ignorent les transform CSS, alors que getBoundingClientRect() les subit.
     Or au survol le LABEL est mis a l'echelle 1.17 (regle injectee plus haut).
     Mesure faite : sur une pastille 27x13, le rect donnait left 17.5 -> 20.48
     et top 19 -> 21.89 des que la souris passait dessus. C'est exactement le
     decalage « vers le bas a droite » qu'on voyait, en selection comme en
     survol. Avec les offsets, les memes mesures restent a 17.5 / 19. */
  function offsetIn(el, ancestor) {
    var x = 0, y = 0, n = el;
    while (n && n !== ancestor) {
      x += n.offsetLeft;
      y += n.offsetTop;
      n = n.offsetParent;
    }
    return n === ancestor ? { x: x, y: y } : null;   // label hors chaine : on renonce
  }

  // Place le badge dans le label (coords relatives au label) + applique la découpe.
  function place(sw, badge, label) {
    var W = sw.offsetWidth, H = sw.offsetHeight;
    if (!W && !H) return;

    var off = offsetIn(sw, label);
    if (!off) return;

    badge.style.left = (off.x + W / 2) + 'px';
    badge.style.top = (off.y + H + 2) + 'px';   // bas du swatch + 2px (transform -50%)

    var bw = Math.round(badge.offsetWidth) || 24;
    var bh = Math.round(badge.offsetHeight) || 12;
    applyCut(sw, W, H, bw, bh, H + 2);
  }

  function badgeOne(sw) {
    var label = sw.closest('label');
    if (!label) return;
    label.style.position = 'relative';

    var badge = document.createElement('span');
    badge.className = 'fm-new-badge' + (sw.closest('.product-card') ? '' : ' fm-new-badge--big');
    badge.setAttribute('aria-hidden', 'true');
    badge.textContent = 'NEW';
    label.appendChild(badge);
    place(sw, badge, label);
  }

  function scan() {
    if (!newSet.length) return;
    document.querySelectorAll('.swatch:not(.fm-new-done)').forEach(function (sw) {
      sw.classList.add('fm-new-done');
      var name = norm(labelFor(sw));
      if (name && newSet.indexOf(name) !== -1) badgeOne(sw);
    });
  }

  /* Recalcule position + découpe des badges DÉJÀ posés.
     force=true : on rebâtit le masque même si rien n'a changé (redimensionnement,
     chargement des polices). force=false : place() recalcule les coordonnées, et
     applyCut ne refait le masque que si la géométrie a réellement bougé — donc
     on peut l'appeler souvent sans coût. */
  function recompute(force) {
    document.querySelectorAll('.swatch.fm-new-done').forEach(function (sw) {
      var label = sw.closest('label');
      if (!label) return;
      var badge = label.querySelector('.fm-new-badge');
      if (badge) {
        if (force) sw._fmCutKey = '';
        place(sw, badge, label);
      }
    });
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      scan();
      /* Les coordonnées du badge sont calculées une fois, à la pose. Or
         sélectionner une pastille change la géométrie : le thème rerend la
         section (prix, titre), la pastille choisie perd sa bordure au profit
         de son anneau, et la rangée se recale de quelques dixièmes de pixel.
         Sans ce recalcul, le badge gardait ses anciennes coordonnées et
         partait légèrement en bas à droite. */
      recompute(false);
    });
  }

  function init() {
    injectCSS();
    scan();

    if (document.body) {
      new MutationObserver(schedule).observe(document.body, {
        childList: true, subtree: true, attributes: true,
        attributeFilter: ['class', 'value', 'aria-label']
      });
    }
    window.addEventListener('resize', function () { requestAnimationFrame(function () { recompute(true); }); });
    window.addEventListener('orientationchange', function () { setTimeout(function () { recompute(true); }, 100); });

    /* Sélection d'une variante : le rerendu du thème est asynchrone, donc on
       repasse une fois tout de suite et une fois après, quand le DOM est posé. */
    document.addEventListener('change', function (e) {
      if (!e.target || !e.target.closest) return;
      if (!e.target.closest('.variant-option__swatch, .variant-picker')) return;
      requestAnimationFrame(function () { recompute(false); });
      setTimeout(function () { recompute(false); }, 200);
    }, true);
    // recalage une fois la police web chargée -> le trou colle pile au badge
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { recompute(true); });
    }
    document.addEventListener('shopify:section:load', schedule);
    window.addEventListener('load', schedule);
    setTimeout(schedule, 300);
    setTimeout(schedule, 1000);
    setTimeout(schedule, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();



/* ============================================================
   BADGE « Nouveau » sur les produits taggés NOUVEAU
   ------------------------------------------------------------
   À COLLER à la fin de  assets/global.js
   (en plus du bloc badge-swatch ; ce sont deux blocs distincts).

   Fonctionne tout seul : pour chaque carte produit, il lit le
   handle, va chercher /products/<handle>.js (qui contient les tags)
   et, si le produit a le tag « NOUVEAU », ajoute le badge.
   Le style .badge-nouveau existe déjà dans product-card.css.

   👉 Réglages ci-dessous : le tag déclencheur et le texte du badge.
   ============================================================ */
(function () {
  var NEW_TAG = 'nouveau';      // tag Shopify qui déclenche le badge (insensible à la casse)
  var BADGE_LABEL = 'Nouveau'; // lu par les lecteurs d'écran (le ★ n'est pas du texte)

  /* ------------------------------------------------------------------
     DEUX RENDUS POSSIBLES POUR LE BADGE
     Renseigne STICKER_URL -> c'est ton image qui s'affiche.
     Laisse la chaine vide -> c'est l'astre dessine (STAR_SVG) qui revient.
     Le reste du code ne change pas.

     L'URL doit etre une image de ta bibliotheque Shopify. On y ajoute
     &width=... : le CDN renvoie alors une version a la bonne taille au lieu
     du fichier d'origine. 160 couvre un badge de 56px sur ecran Retina.
     ------------------------------------------------------------------ */
  var STICKER_URL =
    'https://cdn.shopify.com/s/files/1/0555/1580/8035/files/KQKQ.webp?v=1790423340';
  var STICKER_WIDTH = 200;

  var STAR_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 160 160" preserveAspectRatio="xMidYMid meet" aria-hidden="true" focusable="false"><filter id="fmRough__ID__" x="-12%" y="-12%" width="124%" height="124%"><feTurbulence type="fractalNoise" baseFrequency="0.06" numOctaves="3" seed="4" result="n"/><feDisplacementMap in="SourceGraphic" in2="n" scale="2" xChannelSelector="R" yChannelSelector="G"/></filter><g filter="url(#fmRough__ID__)"><g transform="translate(0.000000,160.000000) scale(0.100000,-0.100000)" fill="currentColor" > <path d="M776 1408 c-3 -13 -13 -63 -21 -113 -29 -163 -70 -275 -100 -275 -20 0 -86 103 -115 179 -22 60 -44 90 -53 74 -3 -5 3 -49 14 -98 20 -96 24 -172 10 -194 -16 -25 -52 0 -172 116 -65 63 -123 113 -130 111 -6 -2 9 -30 35 -63 83 -107 155 -219 162 -252 5 -27 3 -33 -22 -46 -48 -23 -144 -46 -258 -61 -103 -14 -126 -20 -114 -31 3 -3 89 -9 192 -14 119 -6 192 -13 201 -21 13 -10 11 -18 -12 -59 -33 -58 -142 -209 -200 -278 -70 -83 -51 -101 32 -32 132 110 322 239 352 239 25 0 59 -145 69 -294 11 -154 27 -156 55 -9 23 118 59 223 77 231 18 7 73 -49 128 -130 50 -75 69 -86 61 -35 -29 175 -31 197 -15 213 14 14 19 14 49 -1 50 -25 225 -141 290 -192 92 -72 106 -55 28 34 -72 82 -166 208 -190 254 l-20 39 25 10 c41 15 135 29 286 40 80 6 152 14 160 16 30 10 -14 24 -74 24 -68 0 -312 37 -338 51 -10 6 -18 16 -18 24 0 19 170 194 256 266 107 89 77 95 -62 14 -143 -85 -285 -155 -311 -155 -21 0 -23 4 -23 51 0 27 7 82 16 121 21 90 8 109 -32 47 -116 -185 -135 -205 -153 -171 -10 19 -26 152 -37 300 -6 88 -18 118 -28 70z"/> </g></g><path id="fmArc__ID__" d="M54.0 89.5 Q78.0 85.5 102.0 89.5" fill="none"/><g fill="var(--fm-new-text, #fff)" font-family="var(--fm-new-font, Helvetica, Arial, sans-serif)" font-weight="700"><text font-size="18"><textPath href="#fmArc__ID__" xlink:href="#fmArc__ID__" startOffset="50%" text-anchor="middle">NEW</textPath></text></g></svg>';

  var starSeq = 0;

  var tag = NEW_TAG.trim().toLowerCase();
  var cache = {};               // handle -> true / false / 'pending'

  function handleOf(card) {
    var a = card.querySelector('a.product-card__link') || card.querySelector('a[href*="/products/"]');
    var href = a ? (a.getAttribute('href') || '') : '';
    var m = href.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  function addBadge(card) {
    var host = card.querySelector('.product-card__content') || card;
    if (host.querySelector('.badge-nouveau')) return;
    var b = document.createElement('span');
    b.className = 'badge-nouveau';
    /* L'astre est un SVG inline : son corps est en currentColor, donc la
       couleur se règle depuis le CSS (--fm-star-color) sans toucher au
       dessin. Le mot NEW est décoratif — l'info est portée par aria-label. */
    b.setAttribute('role', 'img');
    b.setAttribute('aria-label', BADGE_LABEL);
    /* L'identifiant du filtre doit être unique : plusieurs cartes portent
       le même astre, et deux <filter> de même id dans la page, c'est du
       HTML invalide. On numérote à l'injection. */
    if (STICKER_URL) {
      var sep = STICKER_URL.indexOf('?') === -1 ? '?' : '&';
      var img = document.createElement('img');
      img.src = STICKER_URL + sep + 'width=' + STICKER_WIDTH;
      img.alt = '';           /* l'info est portee par l'aria-label du parent */
      img.loading = 'lazy';
      img.decoding = 'async';
      b.appendChild(img);
    } else {
      b.innerHTML = STAR_SVG.replace(/__ID__/g, String(++starSeq));
    }
    host.appendChild(b);
  }

  // ajoute le badge à TOUTES les cartes de ce handle déjà présentes
  function badgeAll(handle) {
    document.querySelectorAll('.product-card').forEach(function (c) {
      if (handleOf(c) === handle) addBadge(c);
    });
  }

  function handleCard(card) {
    if (card.hasAttribute('data-fm-nouveau-done')) return;
    card.setAttribute('data-fm-nouveau-done', '');

    var handle = handleOf(card);
    if (!handle) return;

    if (cache[handle] === true) { addBadge(card); return; }
    if (cache[handle] === false || cache[handle] === 'pending') return;

    cache[handle] = 'pending';
    fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) { cache[handle] = false; return; }
        var tags = (p.tags || []).map(function (t) { return String(t).trim().toLowerCase(); });
        var isNew = tags.indexOf(tag) !== -1;
        cache[handle] = isNew;
        if (isNew) badgeAll(handle);
      })
      .catch(function () { cache[handle] = false; });
  }

  function scan() {
    document.querySelectorAll('.product-card:not([data-fm-nouveau-done])').forEach(handleCard);
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; scan(); });
  }

  function init() {
    scan();
    if (document.body) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', schedule);
    window.addEventListener('load', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================================================
   ÉTIQUETTE AU SURVOL D'UNE PASTILLE (ordinateur uniquement)
   ------------------------------------------------------------
   Affiche le nom de la variante au-dessus de la pastille survolée, sur les
   cartes produit comme sur la fiche produit.

   Pourquoi UNE seule étiquette flottante posée sur <body>, et pas un ::after
   sur chaque label :
     1. Pitch utilise déjà ::before ET ::after sur .variant-option__button-label
        (styles des pastilles texte) — les détourner casserait ces variantes.
     2. Sur les cartes, le label est mis à l'échelle 1.17 au survol : une
        étiquette posée dedans grandirait avec lui.
     3. .product-card__content est en overflow:hidden — une étiquette interne
        serait rognée près des bords de la carte.
   En position:fixed sur <body>, aucun des trois ne s'applique.

   Le style vit dans brand.css (.fm-swatch-tip), pour rester réglable.
   ============================================================ */
(function () {
  'use strict';

  var ORDI = false;
  try {
    ORDI = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)').matches;
  } catch (e) {}
  if (!ORDI) return;   /* tactile : pas de survol, donc pas d'étiquette */

  /* Vide entre la pointe de l'étiquette et le haut de la pastille. La pointe
     fait partie de la boîte, donc offsetHeight la comprend déjà. */
  var MARGE_HAUT = 7;
  var MARGE_BORD = 6;  /* px mini entre l'étiquette et le bord de l'écran */

  var tip = null;     /* conteneur : porte l'ombre */
  var verre = null;   /* enfant : porte la forme et le verre */
  var ombre = null;   /* frere du verre : porte l'ombre portee */
  var cible = null;
  var masquageDemande = 0;   /* voir cacher() */

  function nomDe(label) {
    var input = label.querySelector('input');
    if (!input) return '';
    /* input.value porte le nom propre de l'option. aria-label est un repli,
       mais il peut contenir un suffixe (« - Épuisé ») : on ne le prend que
       si value est vide. */
    return (input.value || input.getAttribute('aria-label') || '').trim();
  }

  /* Découpe la silhouette complète — bulle arrondie + pointe — en UN seul
     chemin. On la recalcule à chaque affichage parce que la largeur depend
     du nom de la variante.
     Les mesures viennent des variables CSS : le style reste reglable dans
     brand.css sans toucher au script. */
  function decouper(el) {
    var cs = getComputedStyle(el);
    function px(nom, repli) {
      var v = parseFloat(cs.getPropertyValue(nom));
      return v > 0 ? v : repli;
    }
    var r = px('--fm-tip-rayon', 10);
    var pl = px('--fm-tip-pointe-l', 13);
    var ph = px('--fm-tip-pointe-h', 6);

    var W = el.offsetWidth;
    var H = el.offsetHeight;
    var B = H - ph;              /* bas de la bulle, haut de la pointe */
    var cx = W / 2;

    if (r > B / 2) r = B / 2;    /* garde-fou : arrondi plus grand que la bulle */
    if (r > W / 2) r = W / 2;

    /* La silhouette, en coordonnees locales, decalable de (dx, dy). */
    function chemin(dx, dy) {
      function X(v) { return (v + dx).toFixed(2); }
      function Y(v) { return (v + dy).toFixed(2); }
      return 'M ' + X(r) + ',' + Y(0) +
        ' H ' + X(W - r) +
        ' A ' + r + ',' + r + ' 0 0 1 ' + X(W) + ',' + Y(r) +
        ' V ' + Y(B - r) +
        ' A ' + r + ',' + r + ' 0 0 1 ' + X(W - r) + ',' + Y(B) +
        ' H ' + X(cx + pl / 2) +
        ' L ' + X(cx) + ',' + Y(H) +
        ' L ' + X(cx - pl / 2) + ',' + Y(B) +
        ' H ' + X(r) +
        ' A ' + r + ',' + r + ' 0 0 1 ' + X(0) + ',' + Y(B - r) +
        ' V ' + Y(r) +
        ' A ' + r + ',' + r + ' 0 0 1 ' + X(r) + ',' + Y(0) +
        ' Z';
    }

    var d = chemin(0, 0);
    el.style.clipPath = 'path("' + d + '")';
    el.style.webkitClipPath = 'path("' + d + '")';

    /* LE CONTOUR SPECULAIRE.
       Un trait pose sur la silhouette elle-meme : le clip-path en rogne la
       moitie exterieure, il reste donc un liseré net a l'interieur du bord,
       pointe comprise. Degrade du haut vers le bas pour imiter une arete
       qui capte la lumiere d'en haut. */
    var trait =
      "<svg xmlns='http://www.w3.org/2000/svg' width='" + W + "' height='" + H + "'>" +
        '<defs><linearGradient id="g" x1="0" y1="0" x2="0" y2="1">' +
          "<stop offset='0' stop-color='#fff' stop-opacity='.95'/>" +
          "<stop offset='.45' stop-color='#fff' stop-opacity='.45'/>" +
          "<stop offset='1' stop-color='#fff' stop-opacity='.18'/>" +
        '</linearGradient></defs>' +
        "<path d='" + d + "' fill='none' stroke='url(#g)' stroke-width='1.8'/>" +
      '</svg>';
    el.style.setProperty(
      '--fm-tip-contour',
      'url("data:image/svg+xml,' + encodeURIComponent(trait) + '")'
    );

    if (!ombre) return;

    /* L'OMBRE. Deux images SVG de meme taille que le calque :
         - le FOND : la silhouette pleine, descendue de --fm-tip-ombre-y ;
           le CSS la floute et l'attenue.
         - le MASQUE : un rectangle plein PERCE de la silhouette non
           decalee (fill-rule evenodd). Tout ce qui tombe sous le verre est
           donc efface, et rien ne transparait a travers lui.
       Les deux sont recalcules a chaque affichage : la largeur depend du
       nom de la variante. */
    var M = px('--fm-tip-ombre-marge', 26);
    var oy = parseFloat(cs.getPropertyValue('--fm-tip-ombre-y')) || 0;
    var SW = W + 2 * M;
    var SH = H + 2 * M;

    function svg(contenu) {
      return 'url("data:image/svg+xml,' + encodeURIComponent(
        "<svg xmlns='http://www.w3.org/2000/svg' width='" + SW + "' height='" + SH + "'>" +
        contenu + '</svg>'
      ) + '")';
    }

    var fond = svg("<path fill='#000' d='" + chemin(M, M + oy) + "'/>");
    var cache = svg(
      "<path fill='#fff' fill-rule='evenodd' d='" +
      'M0 0H' + SW + 'V' + SH + 'H0Z' + chemin(M, M) + "'/>"
    );

    ombre.style.backgroundImage = fond;
    ombre.style.backgroundSize = SW + 'px ' + SH + 'px';
    ombre.style.webkitMaskImage = cache;
    ombre.style.maskImage = cache;
    ombre.style.webkitMaskSize = SW + 'px ' + SH + 'px';
    ombre.style.maskSize = SW + 'px ' + SH + 'px';
    ombre.style.webkitMaskRepeat = 'no-repeat';
    ombre.style.maskRepeat = 'no-repeat';
  }

  /* Le masquage attend une image : quand on glisse d'une pastille a la
     voisine, le navigateur envoie pointerout PUIS pointerover. Sans ce
     report, l'etiquette se refermerait et se rouvrirait entre les deux,
     ce qui donne un clignotement. montrer() annule le report. */
  function cacher() {
    cible = null;
    if (!tip || masquageDemande) return;
    masquageDemande = requestAnimationFrame(function () {
      masquageDemande = 0;
      tip.classList.remove('is-visible');
    });
  }

  function montrer(label, swatch) {
    var nom = nomDe(label);
    if (!nom) return;

    if (masquageDemande) {              /* on passe d'une pastille a l'autre */
      cancelAnimationFrame(masquageDemande);
      masquageDemande = 0;
    }

    if (!tip) {
      tip = document.createElement('div');
      tip.className = 'fm-swatch-tip';
      tip.setAttribute('aria-hidden', 'true');   /* le nom est déjà lu via l'input */
      /* Deux niveaux : le conteneur porte l'ombre, l'enfant porte la forme.
         Voir la note dans brand.css — une ombre posee sur l'element decoupe
         serait rognee par le decoupage lui-meme. */
      ombre = document.createElement('div');
      ombre.className = 'fm-swatch-tip__ombre';
      verre = document.createElement('div');
      verre.className = 'fm-swatch-tip__verre';
      tip.appendChild(ombre);   /* d'abord : il se peint derriere */
      tip.appendChild(verre);
      document.body.appendChild(tip);
      /* Force le calcul de l'etat de depart (petit, transparent) AVANT
         d'ajouter la classe. Sans cette lecture, le navigateur voit les
         deux etats dans la meme image et n'anime rien : la toute premiere
         apparition serait seche, les suivantes non. */
      void tip.offsetWidth;
    }
    verre.textContent = nom;
    tip.classList.add('is-visible');
    decouper(verre);          /* apres le texte : la largeur en depend */

    /* Mesuré APRÈS avoir écrit le texte : la largeur dépend du nom. */
    var r = swatch.getBoundingClientRect();
    var w = tip.offsetWidth;
    var x = r.left + r.width / 2 - w / 2;
    var max = document.documentElement.clientWidth - w - MARGE_BORD;
    if (x < MARGE_BORD) x = MARGE_BORD;
    if (x > max) x = max;

    tip.style.left = Math.round(x) + 'px';
    tip.style.top = Math.round(r.top - tip.offsetHeight - MARGE_HAUT) + 'px';
    cible = label;
  }

  document.addEventListener('pointerover', function (e) {
    if (e.pointerType === 'touch') return;
    if (!e.target || !e.target.closest) return;
    var label = e.target.closest('.variant-option__button-label');
    if (!label) { if (cible) cacher(); return; }
    var swatch = label.querySelector('.swatch');
    if (!swatch) return;               /* pastille texte : pas d'étiquette */
    if (label === cible) return;
    montrer(label, swatch);
  }, true);

  document.addEventListener('pointerout', function (e) {
    if (!cible || !e.target || !e.target.closest) return;
    if (cible.contains(e.relatedTarget)) return;   /* toujours dans le label */
    cacher();
  }, true);

  /* En position:fixed, l'étiquette ne suit pas la page : on la retire plutôt
     que de la laisser flotter à côté de sa pastille. */
  window.addEventListener('scroll', cacher, true);
  window.addEventListener('resize', cacher);
})();


/* ============================================================
   BADGE « BEST-SELLER » sur les cartes produit
   ------------------------------------------------------------
   Même principe que le badge NEW des pastilles : une liste de noms de
   variantes écrite en dur ci-dessous, et le badge n'apparaît que pour
   celles-là. Ici il se pose sur l'IMAGE de la carte, au milieu à droite,
   et s'efface au survol pour ne pas gêner la 2e photo.

   Le style vit dans product-card.css (.badge-best), pour rester réglable.
   ============================================================ */
(function () {
  'use strict';

  /* >>>>>>>>>>>>>>  LES VARIANTES CONCERNÉES  <<<<<<<<<<<<<<<<<<
     Une par ligne, telles qu'elles s'écrivent dans Shopify. La casse et
     les espaces autour du « | » n'ont pas d'importance, la comparaison
     les normalise. */
  var BEST_VARIANTES = [
    'Sunset',
    'Prude',
    'Foundation',
    'Concealer',
    '04 | Rosewood',
    '01 | Nude'
  ];

  /* L'image du sticker. Vide -> aucun badge n'est posé. */
  var BEST_URL =
    'https://cdn.shopify.com/s/files/1/0555/1580/8035/files/Best_noir.webp?v=1790936784';

  /* Résolution téléchargée. Doit valoir le DOUBLE de --fm-best-size
     (product-card.css) pour rester net sur les écrans Retina.
     --fm-best-size vaut 90px -> 180 ici. */
  var BEST_WIDTH = 180;

  var BEST_LABEL = 'Best-seller';   /* lu par les lecteurs d'écran */

  /* ------------------------------------------------------------------ */

  /* Normalisation : minuscules, espaces resserrés, et espaces retirés
     autour du « | » pour que « 04 | Rosewood » et « 04|Rosewood » soient
     la même chose. */
  function norm(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/\s*\|\s*/g, '|')
      .replace(/\s+/g, ' ')
      .trim();
  }

  var liste = BEST_VARIANTES.map(norm).filter(Boolean);
  if (!liste.length || !BEST_URL) return;

  /* Les noms sous lesquels cette carte se présente, par ordre de fiabilité :
       1. la pastille cochée — c'est la variante réellement affichée ;
       2. le titre de la carte — dans la section « Produits par variant »,
          le titre EST le nom de la variante ;
       3. la 1re pastille, quand rien n'est coché au chargement. */
  function nomsDeLaCarte(card) {
    var noms = [];
    var coche = card.querySelector('.variant-option__swatch input:checked');
    if (coche && coche.value) noms.push(coche.value);

    var titre = card.querySelector('[ref="productTitleLink"]');
    if (titre) noms.push(titre.textContent);

    if (!coche) {
      var premiere = card.querySelector('.variant-option__swatch input');
      if (premiere && premiere.value) noms.push(premiere.value);
    }
    return noms;
  }

  function estBest(card) {
    var noms = nomsDeLaCarte(card);
    for (var i = 0; i < noms.length; i++) {
      if (liste.indexOf(norm(noms[i])) !== -1) return true;
    }
    return false;
  }

  function majCarte(card) {
    /* La galerie plutot que la carte entiere : le badge doit se centrer sur
       l'IMAGE, pas sur la carte panneau compris. */
    var hote = card.querySelector('.card-gallery') ||
               card.querySelector('.product-card__content');
    if (!hote) return;

    var badge = hote.querySelector(':scope > .badge-best');
    var doitEtre = estBest(card);

    if (doitEtre && !badge) {
      badge = document.createElement('span');
      badge.className = 'badge-best';
      badge.setAttribute('role', 'img');
      badge.setAttribute('aria-label', BEST_LABEL);
      var img = document.createElement('img');
      var sep = BEST_URL.indexOf('?') === -1 ? '?' : '&';
      img.src = BEST_URL + sep + 'width=' + BEST_WIDTH;
      img.alt = '';                /* l'info est portee par l'aria-label */
      img.loading = 'lazy';
      img.decoding = 'async';
      badge.appendChild(img);
      hote.appendChild(badge);
    } else if (!doitEtre && badge) {
      badge.remove();              /* la variante choisie n'est plus best-seller */
    }
  }

  function balayer() {
    document.querySelectorAll('.product-card').forEach(majCarte);
  }

  var enAttente = false;
  function programmer() {
    if (enAttente) return;
    enAttente = true;
    requestAnimationFrame(function () {
      enAttente = false;
      balayer();
    });
  }

  function init() {
    balayer();

    if (document.body) {
      new MutationObserver(programmer).observe(document.body, {
        childList: true, subtree: true
      });
    }
    /* Changement de pastille : le badge doit suivre la variante choisie. */
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('.variant-option__swatch')) {
        programmer();
      }
    }, true);
    document.addEventListener('shopify:section:load', programmer);
    window.addEventListener('load', programmer);
    setTimeout(programmer, 400);
    setTimeout(programmer, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* ==========================================================================
   ACCORDÉONS : UN SEUL OUVERT À LA FOIS
   --------------------------------------------------------------------------
   Ouvrir un panneau referme celui qui l'était.

   POURQUOI EN CAPTURE. L'événement `toggle` d'un <details> NE BULLE PAS : un
   écouteur posé sur le conteneur ne le verrait jamais remonter. On écoute donc
   en phase de CAPTURE (3e argument à true), qui traverse l'arbre du haut vers
   le bas et passe donc par le conteneur avant d'atteindre le <details>. C'est
   la même mécanique que setupExclusiveAccordion() dans product.js.

   POURQUOI PAS L'ATTRIBUT `name` NATIF. <details name="..."> donne
   l'exclusivité sans JS, mais il referme le panneau ouvert SANS émettre de
   `toggle` exploitable dans tous les navigateurs, et surtout il impose le
   comportement à la construction du DOM — ici les accordéons sont rendus par
   le thème et réinjectés par l'éditeur, on n'a pas la main sur leur markup.

   PORTÉE : les accordéons des sections de contenu. Le menu, le tiroir mobile
   et les blocs « disclosures » du pied de page ne portent pas la classe
   .accordion et ne sont donc pas concernés. Ceux de la fiche produit sont
   déjà traités par product.js — les deux se contentent de fermer les autres,
   ils ne peuvent pas se contredire.
   ========================================================================== */
(function () {
  'use strict';

  function exclusif() {
    var accs = document.querySelectorAll('.content-for-layout .accordion');
    for (var i = 0; i < accs.length; i++) {
      var acc = accs[i];
      if (acc.__fmExclusif) continue;   /* une seule fois par accordéon */
      acc.__fmExclusif = true;
      acc.addEventListener('toggle', function (e) {
        var d = e.target;
        if (!d || d.tagName !== 'DETAILS' || !d.open) return;
        var autres = this.querySelectorAll('details');
        for (var j = 0; j < autres.length; j++) {
          if (autres[j] !== d && autres[j].open) autres[j].open = false;
        }
      }, true);
    }
  }

  function demarrer() {
    exclusif();
    /* L'éditeur de thème réinjecte des sections entières : on repasse. */
    document.addEventListener('shopify:section:load', exclusif);
    window.addEventListener('load', exclusif);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
